import { Injectable } from '@angular/core';
import { BaseService, ConfigService, LoggingService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';
import { DtoDepotStoreFacade } from '../dto.depot/dto.depot.facade';
import { DtoDeviceStoreFacade } from '../dto.device/dto.device.facade';
import { DtoShipmentProcessStoreFacade } from '../dto.shipment.process/dto.shipment.process.facade';
import { DtoShipmentReturnCodeStoreFacade } from '../dto.shipment.return.code/dto.shipment.return.code..facade';
import { DtoShipmentStoreFacade } from '../dto.shipment/dto.shipment.facade';
import { DtoUserRoleStoreFacade } from '../dto.user.role/dto.user.role.facade';
import { DtoUserStoreFacade } from '../dto.user/dto.user.facade';
import { DtoResourceStoreFacade } from '../dto.resource/dto.resource.facade';
import { DtoResourceTypeStoreFacade } from '../dto.resource.type/dto.resource.type.facade';
import { DtoResourceFaultStoreFacade } from '../dto.resource.fault/dto.resource.fault.facade';

@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendEntityStoreFacadesAccessor extends BaseService {

    constructor(
        configService: ConfigService, loggingService: LoggingService,
        depotStoreFacade: DtoDepotStoreFacade,
        deviceStoreFacade: DtoDeviceStoreFacade,
        shipmentStoreFacade: DtoShipmentStoreFacade,
        shipmentProcessStoreFacade: DtoShipmentProcessStoreFacade,
        shipmentReturnCodeStoreFacade: DtoShipmentReturnCodeStoreFacade,
        userStoreFacade: DtoUserStoreFacade,
        userRoleStoreFacade: DtoUserRoleStoreFacade,
        resourceStoreFacade: DtoResourceStoreFacade,
        resourceTypeStoreFacade: DtoResourceTypeStoreFacade,
        resourceFaultStoreFacade: DtoResourceFaultStoreFacade
    ) {
        super(configService, loggingService, false);

        this.depotStoreFacade = depotStoreFacade;
        this.deviceStoreFacade = deviceStoreFacade;
        this.shipmentStoreFacade = shipmentStoreFacade;
        this.shipmentProcessStoreFacade = shipmentProcessStoreFacade;
        this.shipmentReturnCodeStoreFacade = shipmentReturnCodeStoreFacade;
        this.userStoreFacade = userStoreFacade;
        this.userRoleStoreFacade = userRoleStoreFacade;
        this.resourceStoreFacade = resourceStoreFacade;
        this.resourceTypeStoreFacade = resourceTypeStoreFacade;
        this.resourceFaultStoreFacade = resourceFaultStoreFacade;
    }

    public currentUser: IDtoUser = null;

    public readonly depotStoreFacade: DtoDepotStoreFacade = null;

    public readonly deviceStoreFacade: DtoDeviceStoreFacade = null;

    public readonly shipmentStoreFacade: DtoShipmentStoreFacade = null;

    public readonly shipmentProcessStoreFacade: DtoShipmentProcessStoreFacade;

    public readonly shipmentReturnCodeStoreFacade: DtoShipmentReturnCodeStoreFacade;

    public readonly userStoreFacade: DtoUserStoreFacade = null;

    public readonly userRoleStoreFacade: DtoUserRoleStoreFacade = null;

    public readonly resourceStoreFacade: DtoResourceStoreFacade = null;

    public readonly resourceTypeStoreFacade: DtoResourceTypeStoreFacade = null;

    public readonly resourceFaultStoreFacade: DtoResourceFaultStoreFacade = null;

    protected override async doInitializeAsync(): Promise<void> {
        await super.doInitializeAsync();

        if (this.isInitialized === false) {
            //await this.depotStoreFacade.loadItemsAsync();
        }
    }

}
